import { useEffect, useRef } from "react";
import { tokens } from "@opendoor/tokens-studio/dist/bricks-next/tokens/Components";
import { getTokenValue } from "@tamagui/core";
import { Animated, StyleSheet } from "react-native-web";
import { Box } from "../Box";
import { jsx } from "react/jsx-runtime";
const { image } = tokens, DOT_HEIGHT = getTokenValue(image.size.carouselDots.active.height), ACTIVE_DOT_WIDTH = getTokenValue(image.size.carouselDots.active.width), INACTIVE_DOT_WIDTH = getTokenValue(image.size.carouselDots.other), DOT_MARGIN = 3, VISIBLE_DOTS = 5, PhotoCarouselDots = ({
  length,
  currentIndex
}) => {
  const animatedValues = useRef(
    Array(length).fill(0).map(() => new Animated.Value(0))
  );
  return useEffect(() => {
    animatedValues.current.forEach((value, index) => {
      Animated.timing(value, {
        toValue: index === currentIndex ? 1 : 0,
        duration: 300,
        useNativeDriver: !1
      }).start();
    });
  }, [currentIndex]), /* @__PURE__ */ jsx(Box, { flexDirection: "row", justifyContent: "center", alignItems: "center", children: (() => {
    const start = Math.max(0, Math.min(currentIndex - 2, length - VISIBLE_DOTS)), end = Math.min(start + VISIBLE_DOTS, length);
    return Array(length).fill(0).slice(start, end).map((_, index) => {
      const realIndex = start + index, width = animatedValues.current[realIndex].interpolate({
        inputRange: [0, 1],
        outputRange: [INACTIVE_DOT_WIDTH, ACTIVE_DOT_WIDTH]
      }), opacity = animatedValues.current[realIndex].interpolate({
        inputRange: [0, 1],
        outputRange: [0.5, 1]
      });
      return /* @__PURE__ */ jsx(Box, { "data-testid": `photo-carousel-dot-${realIndex}`, children: /* @__PURE__ */ jsx(
        Animated.View,
        {
          style: [
            styles.dot,
            {
              width,
              opacity
            }
          ]
        }
      ) }, realIndex);
    });
  })() });
}, styles = StyleSheet.create({
  dot: {
    height: DOT_HEIGHT,
    backgroundColor: "white",
    borderRadius: DOT_HEIGHT / 2,
    marginHorizontal: DOT_MARGIN
  }
});
export {
  PhotoCarouselDots
};
